import { AbstractControl, ValidationErrors } from '@angular/forms';
import { get } from 'lodash';

export const passwordMatchValidator = (passwordControlPath: string) => (control: AbstractControl): ValidationErrors | null => {
    return control.value === get(control.root?.value, passwordControlPath)
        ? null
        : { passwordMatch: true };
};

export const passwordStrengthValidator = (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value || '';

    if (!value || value.length < 8) {
        return null;
    }

    if (!/[A-Z]/.test(value)) {
        return { uppercase: true };
    }
    if (!/[a-z]/.test(value)) {
        return { lowercase: true };
    }
    if (!/[0-9]/.test(value)) {
        return { number: true };
    }
    if (!/[@$!%*?&]/.test(value)) {
        return { specialCharacter: true };
    }
    return null;
};
